import LicenseAI from "pages/dashboard/license/ai/[orgid]/page";
import OrderPage from "pages/dashboard/license/order-history/[orderid]/page";
import { useParams } from "react-router-dom";
import { LicenseTab } from "pages/dashboard/license/layout";
export default function Page() {
  const { tabname, id } = useParams();
  if (!id) {
    return;
  }
  switch (tabname) {
    case LicenseTab.History:
      return <OrderPage />;
    case LicenseTab.AI:
      return <LicenseAI />;
    default:
      return;
  }
}
